import { getService } from "../../store/api";
import { getSelectedModel } from "../../store/models";
import { getSelectedVersion } from "../../store/versions";
import { PREDICT_VERSION__BEGIN, PREDICT_VERSION__RESOLVE } from "./types";

const predictVersion = (utterance) => async (dispatch, getState) => {
    const model = getSelectedModel(getState());
    const version = getSelectedVersion(getState());
    if (!model || !version) {
        return null;
    }

    dispatch({ type: PREDICT_VERSION__BEGIN, utterance });

    const service = getService(getState());
    let errors = {};
    let predict = null;
    try {
        const uri =
            `v1/model/${model.id}/` +
            `version/${version.major}.${version.minor}` +
            `/predict`
            ;
        const response = await service.fetchEndpoint(uri, 'POST', utterance, true);
        predict = await response.json();
    } catch (response) {
        errors = await service.getErrors(response, 'utterance');
    }

    dispatch({ type: PREDICT_VERSION__RESOLVE, predict, errors });
    return predict;
};

export default predictVersion;
